/**
 * El backend manda las horas como llegan de la base: "08:00:00" para un
 * horario, "2026-09-14T07:38:14" para un registro. En pantalla eso es
 * ruido; una persona lee "08:00" y "07:38".
 */

/** Hora y minutos ("HH:mm") de una hora suelta o de una fecha con hora. */
export function soloHora(valor: string | Date | null | undefined): string {
  if (!valor) {
    return "";
  }
  if (valor instanceof Date) {
    return `${dosDigitos(valor.getHours())}:${dosDigitos(valor.getMinutes())}`;
  }
  const texto = `${valor}`.trim();
  // La primera pareja hh:mm es la hora, venga sola o detrás de la fecha.
  const hora = /(\d{1,2}):(\d{2})/.exec(texto);
  return hora ? `${dosDigitos(Number(hora[1]))}:${hora[2]}` : texto;
}

/** Solo el día ("yyyy-MM-dd") de una fecha que puede venir con hora. */
export function soloFecha(valor: string | Date | null | undefined): string {
  if (!valor) {
    return "";
  }
  if (valor instanceof Date) {
    return `${valor.getFullYear()}-${dosDigitos(valor.getMonth() + 1)}-${dosDigitos(valor.getDate())}`;
  }
  const texto = `${valor}`.trim();
  return texto.length >= 10 ? texto.substring(0, 10) : texto;
}

function dosDigitos(n: number): string {
  return `${n}`.padStart(2, "0");
}
